// extracted by mini-css-extract-plugin
export default {"wrap":"fu-z","fullWidth":"gu-z","searchPlacement":"hu-z","items":"iu-z","featureCss":"ju-z","disabled":"ku-z","imgCss":"lu-z"};